import { render, staticRenderFns } from "./palletTable.vue?vue&type=template&id=4c81010c&scoped=true"
import script from "./palletTable.vue?vue&type=script&lang=js"
export * from "./palletTable.vue?vue&type=script&lang=js"
import style0 from "./palletTable.vue?vue&type=style&index=0&id=4c81010c&lang=scss&scoped=true"
import style1 from "./palletTable.vue?vue&type=style&index=1&id=4c81010c&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c81010c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c81010c')) {
      api.createRecord('4c81010c', component.options)
    } else {
      api.reload('4c81010c', component.options)
    }
    module.hot.accept("./palletTable.vue?vue&type=template&id=4c81010c&scoped=true", function () {
      api.rerender('4c81010c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/purchase/order/csg-admin/palletTable.vue"
export default component.exports